// extracted by mini-css-extract-plugin
export default {"info_today":"xmSb7OIQPX"};